import React from 'react';
import {Box, Button, FormControl, MenuItem, Select} from "@mui/material";
import Container from "@mui/material/Container";
import Faq, {FaqCategory, FaqCategoryName} from "@/types/faq";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useCreateFaqMutation, useUpdateFaqMutation} from "@/redux/apis";
import {LoadingButton} from "@mui/lab";
import Label from "@/components/form/label";
import LayoutDialog from "@/components/layout/layout-dialog";
import Stack from "@mui/material/Stack";
import {apiEndpoints} from "@/utils/api-endpoints";
import {mutate} from "swr";
import {Field} from '@/components/form';


export default function CreateEditModal({visible, onClose, dataToEdit}: {
    visible: boolean,
    onClose: () => void;
    dataToEdit?: Faq;
}) {

    const [createFaq, {isLoading}] = useCreateFaqMutation();
    const [updateFaq, {isLoading: isUpdating}] = useUpdateFaqMutation();

    const formik = useFormik({
        initialValues: {
            question: dataToEdit?.question || '',
            answer: dataToEdit?.answer || '',
            category: dataToEdit?.category || FaqCategory.LoginAndSignUp,
        },
        validationSchema: Yup.object({
            question: Yup.string()
                .required('لطفا سوال را وارد کنید'),
            answer: Yup.string()
                .required('لطفا پاسخ را وارد کنید'),
            category: Yup.number()
                .typeError('لطفا دسته بندی را انتخاب کنید')
                .required('لطفا دسته بندی را انتخاب کنید'),

        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const parsedCategory = Number(values.category);

                const payload = {
                    question: values.question,
                    answer: values.answer,
                    category: parsedCategory,
                };

                if (dataToEdit) {
                    await updateFaq({
                        id: dataToEdit.id,
                        ...payload,
                    }).unwrap();
                } else {
                    await createFaq(payload).unwrap();
                }

                await mutate(apiEndpoints.Faq.GetAll.url);

                resetForm();
                onClose();
            } catch (error) {
                console.error("FAQ request failed:", error);
            }
        }
    })

    return (

        <LayoutDialog
            open={visible}
            handleClose={onClose}
            title={dataToEdit ? "ویرایش سوال و جواب" : "سوال و جواب جدید"}
            maxWidth="xs"
            dialogActions={
                <Stack width="100%" spacing={2} direction="row">
                    <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disableElevation
                        onClick={() => {
                            formik.resetForm();
                            onClose();
                        }}
                    >
                        لغو
                    </Button>

                    <LoadingButton
                        type="submit"
                        form="faq-form"
                        fullWidth
                        loading={isLoading || isUpdating}
                        variant="contained"
                        color="secondary"
                        disableElevation
                    >
                        تایید
                    </LoadingButton>
                </Stack>
            }
        >
            <form
                id="faq-form"
                onSubmit={formik.handleSubmit}
            >
                <Field.Text
                    label="سوال"
                    name="question"
                    value={formik.values.question}
                    onChange={formik.handleChange}
                    multiline
                    rows={2}
                    fullWidth
                    placeholder="اینجا بنویسید..."
                    sx={{ mb: 2 }}
                />

                <Field.Text
                    label="پاسخ"
                    name="answer"
                    value={formik.values.answer}
                    onChange={formik.handleChange}
                    multiline
                    rows={5}
                    fullWidth
                    placeholder="اینجا بنویسید..."
                    sx={{
                        mb: 2,

                        "& textarea": {
                            resize: "vertical",
                        },
                    }}
                />

                <Label>دسته</Label>

                <FormControl fullWidth>
                    <Select
                        name="category"
                        value={formik.values.category}
                        onChange={formik.handleChange}
                    >
                        {Object.keys(FaqCategoryName).map((key) => (
                            <MenuItem key={key} value={key}>
                                {FaqCategoryName[key]}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </form>
        </LayoutDialog>    );
};

